<template>
<div class="pay_box">
  <template v-if="showPage">
  <section class="date_box">
    <section :class="['date_box_top',monthList.length <= 2?'date_box_flex':'']">
      <section class="date_start">
        <p>合同开始</p>
        <p>{{dateMess.applayStartDay | formatTime(6)}}</p>
      </section>
      <p :class="['date_item',item.isCurMonth?'cur_month':'',item.payStatus == '已缴'?'have_pay':'']" v-for="(item,index) in monthList" :key="item.month">
        <span>{{item.monthText}}</span>
        <span class="cur_month_t" v-if="item.isCurMonth">本月</span>
        <span class="have_paytext" v-if="item.payStatus == '已缴'">已缴</span>
        <span class="date_year" v-if="!item.isCurMonth && item.year != monthList[monthList.length-1].year">{{item.year}}</span>
      </p>
      <img v-if="dateMess.monthList.length > 12" class="icon_more" src="../../assets/images/icon_more.png" />
      <section class="date_start">
        <p>合同结束</p>
        <p>{{dateMess.applayEndDay | formatTime(6)}}</p>
      </section>
    </section>
    <section class="record" @click="toPayRecord">
      <p>缴费记录</p>
      <img src="../../assets/images/icon_indicator_next.png" />
    </section>
  </section>
  <template v-if="dateMess.hasPay">
    <!-- 如果有待支付的订单 -->
    <template v-if="pendingBill">
       <ul class="pay_data pendingBill_data">
        <li class="pay_data_item">
          <span>充值起始时间</span>
          <p>{{pendingBill.startDay}}</p>
        </li>
        <li class="pay_data_item">
          <span>充值结束时间</span>
          <p>{{pendingBill.endDay}}</p>
        </li>
        <li class="pay_data_item">
          <span>月租费</span>
          <p>¥ {{dateMess.feeStandard|priceFormat}}</p>
        </li>
        <li class="pay_data_item">
          <span>需支付金额</span>
          <p class="price">¥ {{pendingBill.amount|priceFormat}}</p>
        </li>
      </ul>
    </template>
    <template v-else>
      <!-- 日期选择box -->
      <section class="select_box">
        <section class="select_box_date">
          <p>缴费开始月份</p>
          <section class="select_date_item" @click="selectTime(1)">
            <span class="span">{{startDay}}</span>
            <!--  :start-date="rangeStartTime" :end-date="rangeEndTime" -->
            <!-- <yd-datetime ref="startDay" class="span" type="month" v-model="startDay"></yd-datetime> -->
            <img src="../../assets/images/icon_indicator_next.png" />
          </section>
        </section>
        <section class="select_center"></section>
        <section class="select_box_date">
          <p>缴费结束月份</p>
          <section class="select_date_item" @click="selectTime(2)">
            <span class="span">{{endDay}}</span>
            <!--  :start-date="startDay+'-01'" :end-date="rangeEndTime" -->
            <!-- <yd-datetime ref="endDay" class="span" type="month" v-model="endDay"></yd-datetime> -->
            <img src="../../assets/images/icon_indicator_next.png" />
          </section>
        </section>
      </section>
      <template  v-if="showPayMessage">
        <section v-if="payMess.giveMsg" class="give_msg"><span>满赠</span><p>{{payMess.giveMsg}}</p></section>
        <section v-for="(item,index) in records" :key="index">
          <!-- 提示 -->
          <section class="tips" v-if="item.diffDay">
            <img src="../../assets/images/parking/icon_hint.png" />
            <p>租赁期内非整月应缴费用按照当月实际天数折算</p>
          </section>
          <p v-if="!item.diffDay && index != 0" class="all_month">整月充值部分</p>
          <!-- 数据 -->
          <ul class="pay_data">
            <li class="pay_data_item">
              <span>充值起始时间</span>
              <p>{{item.startDay | formatTime(9)}}</p>
            </li>
            <li class="pay_data_item">
              <span>充值结束时间</span>
              <p>{{item.endDay | formatTime(9)}}</p>
            </li>
            <li class="pay_data_item">
              <span>月租费</span>
              <p>¥ {{item.feeStandard|priceFormat}}</p>
            </li>
            <li class="pay_data_item" v-if="item.diffDay">
              <span>首月应缴天数</span>
              <p>{{item.diffDay}}天</p>
            </li>
            <li class="pay_data_item">
              <span>需支付金额</span>
              <p class="price">¥ {{item.amount|priceFormat}}</p>
            </li>
          </ul>
        </section>
      </template>
    </template>
  </template>
  <!-- 全部缴费完成 -->
  <section class="all_pay" v-else>
    <img src="../../assets/images/icon_blank_praise.png" />
    <p>已全部缴清合同期内剩余月租费</p>
    <span>好棒！点个赞</span>
  </section>
  <section class="footer_h"></section>
  <!-- 返回上一份合同 -->
  <template v-if="!isCurContract">
    <section class="footer_xq"></section>
    <p :class="['back_contract',showPayMessage?'':'msg_box_b']" @click="backContract">返回上一份合同</p>
  </template>
  <!-- 您已续签，去缴续签合同 -->
  <template v-if="xqContractId && isCurContract && showPayMessage && !pendingBill">
    <section class="footer_xq"></section>
    <section :class="['xq_textbox',showPayMessage?'':'msg_box_b']" @click="toXuqian">
      <p>您已续签，去缴续签合同</p>
      <img src="../../assets/images/icon_indicator_next.png" />
    </section>
  </template>
  <common-footer v-if="xqContractId && isCurContract && !showPayMessage && !pendingBill" text="您已续签，去缴续签合同" :canClick="true" @btnClick="toXuqian"></common-footer>
  <common-footer v-if="!pendingBill && showPayMessage" :text="`立即支付¥ ${needPayPrice}`" :canClick="canClick" @btnClick="btnClick"></common-footer>
  <template v-if="pendingBill">
    <section class="footer_tips" v-if="waitPay"></section>
    <section class="wait_pay_tips" v-if="waitPay" @click="waitPay=false">
      <img class="tips_icon" src="../../assets/images/parking/icon_hint.png" />
      <p>您有未完成的缴费单</p>
      <img class="close_icon" src="../../assets/images/parking/close.png" />
    </section>
    <footer class="footer_box button">
      <span class="btn_primary btn_left" @click="cancelPay">取消支付</span>
      <span class="btn_default btn_right" @click="paySubmit">立即支付</span>
    </footer>
  </template>
  <yd-datetime style="display:none;" ref="datetime" @input="dateChange" type="month" v-model="date" :startDate="rangeStartTime" :endDate="rangeEndTime"></yd-datetime>
  <!-- <yd-datetime style="display:none;" ref="startDay" v-model="startDay" type="month"></yd-datetime>
  <yd-datetime style="display:none;" ref="endDay" v-model="endDay" type="month"></yd-datetime> -->
  </template>
  <!-- 有满减活动 -->
  <template v-if="dateMess.rechargeGiveMsg && !pendingBill && dateMess.hasPay">
    <section class="msg_height"></section>
    <section :class="['msg_box',showPayMessage?'':'msg_box_b',xqContractId && showPayMessage?'msg_box_c':'',xqContractId && !showPayMessage?'msg_box_d':'']">
      <section class="msg_box_m">
        <img src="../../assets/images/icon_park_notice.png" />
        <p>{{dateMess.rechargeGiveMsg}}</p>
        <span @click="lookDetail">详情</span>
      </section>
    </section>
  </template>
</div>
</template>

<script>
import CommonFooter from '../../components/footer';
import util from '../../utils/util';
import storage from '../../utils/storage';
import {loadParkHeaderById,removeRequestOrder} from '../../utils/api';
import {mapState} from 'vuex';
import ping from '../../utils/pingpay.js'
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
let timer = null;
export default {
  name: 'parkingPay',
  props: {},
  components: {
    CommonFooter
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    }),
    monthList(){
      let monthList = this.dateMess.monthList || [];
      let curMonth = new Date().getMonth()+1;
      let curYear = new Date().getFullYear()
      monthList.forEach(item=>{
        item.monthText = util.formatTime(new Date(item.month),15)
        item.isCurMonth = curMonth == util.formatTime(new Date(item.month),17).month && curYear == util.formatTime(new Date(item.month),17).year
        item.year = util.formatTime(new Date(item.month),16)
      })
      return monthList.filter((item,index)=>{return index < 12})
    }
  },
  data() {
    return {
      canClick:true,
      waitPay:true,
      changeStartDate:false,
      showPage:false,
      dateMess:'',
      date:'',
      startDay:'2019/01',//开始月份
      endDay:'2029/01',//结束月份
      time:'',
      rangeStartTime:'',//开始可选时间
      userS:false,
      showPayMessage:'',
      feeStandard:'',//月租费
      records:[],
      needPayPrice:'',
      pendingBill:'',//待支付的订单数据
      amount:'',//应付价格
      giveCount:0,//赠送月数
      canPay:true,
      payMess:'',
      xqContractId:'',//续签合同id
      isCurContract:true,//是否是当前合同
      rangeEndTime:''//结束可选时间
    }
  },
  created() {
    this.xqContractId = this.$route.query.xqContractId || '';
    this.queryCurrentBill()
  },
  mounted(){
  },
  methods: {
    datetime(){
    },
    lookDetail(){
       util.showModal('',`${this.dateMess.rechargeGiveMsg}`,false,'我知道了',()=>{})
    },
    // 获取用户申请信息
    queryCurrentBill(applayLogId){
      util.showLoading()
      let params = {
        id:Number(this.$route.query.id),//车位id
        applayLogId:applayLogId,//合同id
        url:"/parking/rstParkLot/queryCurrentBill"
      }
      loadParkHeaderById(params).then(res=>{
        this.showPage = true;
        this.userS = false;
        console.log(res)
        util.hideLoading()
        if(res.res.code === 10000 && res.body && res.body.data){
          this.dateMess = res.body.data.data;
          if(this.dateMess.startDay){
            this.startDay =util.formatTime(new Date(this.dateMess.startDay),44);//选择的开始时间
          }
          if(this.dateMess.endDay){
            this.endDay =util.formatTime(new Date(this.dateMess.endDay),44);//选择的结束时间
          }
          let {year,month} = util.formatTime(new Date(res.body.data.data.applayStartDay),17);//合同开始时间
          this.rangeStartTime = util.formatTime(new Date(year+"/"+month+'/01 00:00:00'),19);
          this.rangeEndTime = util.formatTime(new Date(res.body.data.data.applayEndDay),19);//合同结束时间
          if(this.dateMess.pendingBill){
            this.pendingBill = this.dateMess.pendingBill
          }else{
            if(this.dateMess.hasPay){
              this.queryParkFee(util.formatTime(new Date(this.dateMess.startDay),9),util.formatTime(new Date(this.dateMess.endDay),9))
            }
          }
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    // 获取支付数据
    queryParkFee(startDay,endDay){
      util.showLoading()
      let params = {
        id:Number(this.$route.query.id),
        startDay:startDay,
        endDay:endDay,
        url:"/parking/rstParkLot/queryParkFee"
      }
      if(!this.isCurContract && this.xqContractId){
        params.applayLogId = this.xqContractId//合同id
      }
      loadParkHeaderById(params).then(res=>{
        console.log(res)
        if(res.res.code === 10000){
          util.hideLoading()
          this.userS = true;
          if(res.body && res.body.data && res.body.data.data){
            this.showPayMessage = true;
            this.payMess = res.body.data.data;
            this.records = this.payMess.records || [];
            this.amount = this.payMess.amount;
            this.feeStandard = this.payMess.feeStandard;
            this.needPayPrice = util.priceFormat(res.body.data.data.allAmount);
          }else{
            this.showPayMessage = false;
            util.showToast(res.body.data.msg,2000)
          }
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    // 选择开始时间
    startDateChange(val){
      console.log(val)
      if(!this.userS){return;}
      this.startDay = val;
      // 判断,如果开始时间大于结束时间,重置结束时间
      let startT = new Date((this.startDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
      let endT = new Date((this.endDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
      if(endT < startT){
        this.endDay = val;
      }
      this.commonComputed()
    },
    // 选择结束时间
    endDateChange(val){
      if(!this.userS){
        return;
      }
      this.endDay = val;
      // 判断,如果开始时间大于结束时间,重置开始时间
      let startT = new Date((this.startDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
      let endT = new Date((this.endDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
      if(endT < startT){
        this.startDay = val;
      }
      this.commonComputed()
    },
    commonComputed(){
      let start = '';
      let end = '';
      let rangeStartTime = this.rangeStartTime.split('/');
      let rangeEndTime = this.rangeEndTime.split('/');
      let startTime = this.startDay.split('-');
      let endTime = this.endDay.split('-');
      // 判断是否是合同开始的第一个月
      if(rangeStartTime[0] == startTime[0] && rangeStartTime[1] == startTime[1]){
        start = util.formatTime(new Date(this.dateMess.applayStartDay),9)
      }else{
        start = util.formatTime(new Date((this.startDay+'-01').replace(/-/g,'/')+' 00:00:00'),9)
      }
      // 判断是否是合同最后的一个月
      if(rangeEndTime[0] == endTime[0] && rangeEndTime[1] == endTime[1]){
        end = util.formatTime(new Date(this.dateMess.applayEndDay),9)
      }else{
        let endt = new Date(endTime[0],endTime[1],0);
        let {year,month,day} = util.formatTime(endt,17);
        end = util.formatTime(new Date(year+'/'+month+'/'+day+' 23:59:59'),9)
      }
      this.queryParkFee(start,end)
    },
    nameInputFun(e){
      this.$emit('inputChange',{val:e.data,type:'name'})
    },
    selectTime(val){
      this.timeT = val;
      this.userS = true;
      this.$refs.datetime.open();
    },
    dateChange(val){
      console.log(val)
      if(!this.userS){
        return false;
      }
      if(this.timeT == '1'){
        this.startDay = val;
        // 判断,如果开始时间大于结束时间,重置结束时间
        let startT = new Date((this.startDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        let endT = new Date((this.endDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        if(endT < startT){
          this.endDay = val;
        }
      }else{
        this.endDay = val;
        // 判断,如果开始时间大于结束时间,重置开始时间
        let startT = new Date((this.startDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        let endT = new Date((this.endDay+'-01').replace(/-/g,'/')+' 00:00:00').getTime()
        if(endT < startT){
          this.startDay = val;
        }
      }
      this.commonComputed()
    },
    // 支付
    paySubmit(){
      this.goPayCenter(this.pendingBill.payOrderNo)
    },
    // 取消订单
    cancelPay(){
      util.showModal('','确定要取消支付吗?',true,'确定',()=>{
        removeRequestOrder({requestNo:this.pendingBill.orderNo}).then(res=>{
          if(res.res.code === 10000){
            this.showPayMessage = false;
            this.pendingBill = ''
            util.showToast('已取消')
            this.userS = false;
            if(this.isCurContract){
              this.queryCurrentBill()
            }else{
              this.queryCurrentBill(this.xqContractId)
            }
          }else{
            util.showToast(res.res.msg)
          }
        })
      })
    },
    goPayCenter (orderNo) {
      let that = this;
      if(!this.canPay){
        return;
      }
      this.canPay = false
      let params = {
        orderNo: orderNo,
        repairNo: '', // "报修单号",
        bussinessType:"7",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6,7停车
        feeCode:this.$route.query.parkHeaderId, //7停车传车场id
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      ping(params,'',res => {
          console.log(res);
          storage.setS("isNeedFresh",true)
          util.showLoading('支付确认中,请稍后...')
          // 定时查询,如果没有待支付订单数据,停止定时器
          timer = setInterval(()=>{
            let params = {
              id:Number(this.$route.query.id),//车位id
              applayLogId:'',//合同id
              url:"/parking/rstParkLot/queryCurrentBill"
            }
            if(!that.isCurContract){
              params.applayLogId = this.xqContractId
            }
            loadParkHeaderById(params).then(res=>{
              if(res.res.code === 10000 && res.body && res.body.data){
                if(!res.body.data.data.pendingBill){
                  this.dateMess = res.body.data.data;
                  this.pendingBill = ''
                  this.showPayMessage = false;
                  clearInterval(timer)
                  util.hideLoading()
                  this.userS = false;
                  if(that.isCurContract){
                    that.queryCurrentBill()
                  }else{
                    that.queryCurrentBill(that.xqContractId)
                  }
                }
              }
            })
          },2000)
        },
        () => {
          that.userS = false;
          if(that.isCurContract){
            that.queryCurrentBill()
          }else{
            that.queryCurrentBill(that.xqContractId)
          }
        },
        () => {
          that.userS = false;
          if(that.isCurContract){
            that.queryCurrentBill()
          }else{
            that.queryCurrentBill(that.xqContractId)
          }
        },
        ()=>{
          // 订单状态已变更,取消订单
          removeRequestOrder({requestNo:this.pendingBill.orderNo}).then(res=>{
            if(res.res.code === 10000){
              this.showPayMessage = false;
              this.pendingBill = ''
              this.queryCurrentBill()
            }else{
              util.showToast(res.res.msg)
            }
          })
        }
      );
      setTimeout(()=>{
        this.canPay = true
      },1000)
    },
    toPayRecord(){
      this.$router.push(`/parkingPayRecord?id=${this.$route.query.id}`)
    },
    btnClick(){
      this.canClick = false;
      util.showLoading()
      let params = {
        parkHeaderId:this.$route.query.parkHeaderId,//车场id
        subProjectId:this.common.marketInfo.id,
        parkLotId:this.$route.query.id,//车位id
        numberType:2,//1、企业付费车位；2、个人月租；
        amount:this.payMess.allAmount,//账单金额
        payAmount:this.payMess.allAmount,//支付金额
        plateNo:'',//车牌号
        openId:this.common.openId,
        userId:this.common.userId,
        userName:this.common.userTenantInfo.userName || this.common.userInfo.userName,
        phone:this.common.userInfo.account || this.common.userInfo.phone,
        payCharge:0,//手续费
        receivableMoney:0,//实际到账金额
        monthCount:0,
        giveCount:this.giveCount,//赠送月数
        startDay:util.formatTime(new Date(this.records[0].startDay),9),
        endDay:util.formatTime(new Date(this.records[this.records.length - 1].endDay),9),
        url:'/parking/rstParkBill/parkMonthlyBill'
      }
      loadParkHeaderById(params).then(res=>{
        util.hideLoading()
        console.log(res)
        if(res.res.code === 10000 && res.body && res.body.data){
          this.goPayCenter(res.body.data.orderNo)
        }else{
          util.showToast(res.res.msg)
        }
        this.canClick = true;
      })
    },
    toXuqian(){
      this.isCurContract = false;
      this.queryCurrentBill(this.xqContractId)
    },
    backContract(){
      this.isCurContract = true;
      this.showPayMessage = false;
      this.queryCurrentBill()
    }
  },
  destroyed() {
    clearTimeout(timer);
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.pay_box{
  overflow: hidden;
}
.date_box{
  background:#eee url('../../assets/images/parking_bg.png') left center no-repeat;
  background-size:100% 100%;
  height:300px;
  width:100%;
  .date_box_top{
    padding:68px 28px 60px;
    height:96px;
    .flex();
    flex-wrap: nowrap;
    align-items: center;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    .date_start{
      height:96px;
      .flex(column);
      align-items: flex-start;
      justify-content: center;
      padding-right:28px;
      p{
        font-size:26px;
        color:rgba(102,102,102,1);
        line-height:36px;
      }
    }
    .date_item{
      width:96px;
      height:96px;
      flex-shrink: 0;
      border-radius: 100%;
      .flex(column);
      align-items: center;
      justify-content: center;
      margin-right:40px;
      background:#E2E2E2;
      position: relative;
      span{
        font-size:32px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height: 44px;
        &.date_year{
          position: absolute;
          top:-48px;
          left:50%;
          transform: translate(-50%);
          font-size:26px;
          line-height:36px;
          color:#666;
          font-weight: normal;
        }
      }
      .have_paytext{
        position: absolute;
        top:100px;
        left:50%;
        transform: translate(-50%);
        color:#16BC84;
        font-size:24px;
      }
    }
    .icon_more{
      width:36px;
      height:36px;
      margin-right:20px;
      margin-left:-20px;
    }
    .cur_month{
      background:#1740DA;
      span{
        color:#fff;
        &.cur_month_t{
          font-size:20px;
          color:#fff;
          line-height: 28px;
        }
      }
    }
    .have_pay{
      background:#16BC84;
      span{
        color:#fff;
        &.cur_month{
          font-size:20px;
          color:#fff;
          line-height: 28px;
        }
      }
    }
  }
  .date_box_flex{
    width:100%;
    .flex();
    justify-content: center;
  }
  .record{
    .flex();
    justify-content: flex-end;
    height:40px;
    align-items: center;
    padding-right:20px;
    p{
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:40px;
      margin-right:4px;
    }
    img{
      width:32px;
      height:32px;
    }
  }
}
.select_box{
  padding:40px 20px;
  .flex();
  align-items: center;
  .select_box_date{
    .flex(column);
    justify-content: space-between;
    align-items: center;
    flex:1;
    p{
      font-size:28px;
      color:rgba(102,102,102,1);
      line-height:40px;
      margin-bottom:14px;
    }
    .select_date_item{
      position: relative;
      width:100%;
      height:100px;
      .border();
      box-shadow:0px 4px 16px 0px rgba(0,0,0,0.06);
      border-radius:8px;
      text-align:center;
      img{
        position:absolute;
        width:32px;
        height:32px;
        right:20px;top:34px;
      }
      .span{
        font-size:32px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height: 100px;
      }
    }
  }
  .select_center{
    height:100px;
    line-height: 100px;
    font-size:32px;
    color:rgba(51,51,51,1);
    margin:0 16px;
    margin-top:54px;
    width:20px;
    position: relative;
    &:after{
      position: absolute;
      content:'';
      left:50%;top:50%;
      transform: translate(-50%,-50%);
      width:20px;
      height:4px;
      background:#666;
      border-radius: 2px;
    }
  }
}
.tips{
  padding:8px 20px 20px;
  height:36px;
  align-items: center;
  .flex();
  img{
    width:28px;
    height:28px;
    margin-right:14px;
  }
  p{
    font-size:26px;
    color:rgba(253,152,56,1);
    line-height:36px;
  }
}
.all_month{
  height:36px;
  font-size:26px;
  color:rgba(153,153,153,1);
  line-height:36px;
  margin-bottom:20px;
  margin-left:28px;
}
.pay_data{
  margin:0 20px 28px;
  background:rgba(248,248,248,1);
  border-radius:8px;
  padding:28px 28px 0;
  overflow: hidden;
  .pay_data_item{
    .flex();
    justify-content: space-between;
    margin-bottom:28px;
    span{
      font-size:28px;
      color:rgba(102,102,102,1);
      line-height:40px;
    }
    p{
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:40px;
      &.price{
        color:#fc3f56;
        font-weight:bold;
      }
    }
  }
}
.pendingBill_data{
  margin-top:40px;
}
.all_pay{
  .flex(column);
  justify-content: center;
  align-items: center;
  margin:200px auto 300px;
  width:100%;
  img{
    width:100px;
    height:100px;
    margin-bottom:28px;
  }
  p{
    font-size:36px;
    color:rgba(51,51,51,1);
    line-height:50px;
    margin-bottom:20px;
  }
  span{
    font-size:28px;
    color:rgba(153,153,153,1);
    line-height:40px;
  }
}
.footer_h{
  height:120px;
}
.msg_height{
  height:108px;
}
.footer_tips{
  height:88px;
}
.wait_pay_tips{
  position: fixed;
  bottom:108px;left:0;right:0;
  background:#FEEEDF;
  height:88px;
  .flex();
  box-sizing: border-box;
  padding:0 28px;
  align-items: center;
  .tips_icon{
    width:28px;height:28px;
    margin-right:14px;
  }
  p{
    font-size:26px;
    color:rgba(142,127,113,1);
  }
  .close_icon{
    position: absolute;
    top:0;right:0;
    width:44px;
    height:44px;
    padding:22px 10px;
  }
}
.footer_box{
  position: fixed;
  bottom:0;left:0;right:0;
  height:108px;
  background:#fff;
  .flex();
  align-items: center;
  padding:0 28px;
  box-sizing: border-box;
  span{
    flex:1;
    height:68px;
    line-height: 68px;
    text-align:center;
    font-size:28px;
    color:#fff;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .btn_left{
    margin-right:15px;
    .border(rgba(150,170,240,1));
    background:rgba(243,245,253,1);
    color:@color17;
  }
  .btn_right{
    margin-left:15px;
    background:@color17;
  }
}
.give_msg{
  font-size:26px;
  color:rgba(252,63,86,1);
  line-height:36px;
  margin-bottom:20px;
  padding:0 28px;
  width:100%;
  box-sizing: border-box;
  .flex();
  span{
    flex-shrink: 0;
    padding:0 6px;
    height:36px;
    box-sizing: border-box;
    margin-right:8px;
    .border(#fd9faa);
    border-radius: 4px;
  }
  p{
    flex:1;
    word-break: break-all;
  }
}
.msg_box{
  position:fixed;
  bottom:108px;
  left:0;right:0;
  box-sizing: border-box;
  background:#fff;
  padding:20px;
  .msg_box_m{
    height:68px;
    .flex();
    align-items: center;
    border-radius: 34px;
    background:#f0f5fc;
  }
  img{
    width:32px;
    height:32px;
    margin-right:14px;
    margin-left:20px;
  }
  p{
    font-size:24px;
    color:rgba(102,102,102,1);
    flex:1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 44px;
  }
  span{
    font-size:24px;
    color:rgba(23,64,218,1);
    padding:0 20px 0 40px;
    line-height: 44px;
  }
}
.footer_xq{
  height:76px;
}
.back_contract{
  height:76px;
  line-height:76px;
  text-align:center;
  background:#fff;
  position:fixed;
  bottom:108px;left:0;right:0;
  color:@color17;
  font-size:28px;
  box-sizing:border-box;
  box-shadow:0 -4px 12px 0 rgba(0,0,0,0.06);
}
.xq_textbox{
  height:76px;
  line-height:76px;
  text-align:center;
  background:#fff;
  position:fixed;
  bottom:108px;left:0;right:0;
  color:@color17;
  font-size:28px;
  .flex();
  align-items:center;
  justify-content:center;
  img{
    width:32px;
    height:32px;
    margin-left:8px;
  }
}
.msg_box_b{
  bottom:0;
}
.msg_box_c{
  bottom:186px;
}
.msg_box_d{
  bottom:76px;
}
</style>
